import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Coins, Sparkles, ArrowLeft, Gift } from "lucide-react";

export default function EarnGoldly() {
  const [rules, setRules] = useState([]);
  useEffect(() => { api.get("/rules/earn-goldly").then(r => setRules(r.data?.rules || [])); }, []);

  return (
    <div className="px-4 py-6 pb-24" data-testid="earn-goldly-page">
      <Link to="/more" className="flex items-center gap-1 text-xs text-white/60 mb-3" data-testid="earn-back"><ArrowLeft className="w-3.5 h-3.5"/>Back</Link>
      <div className="flex items-center gap-2 mb-1">
        <Coins className="w-7 h-7 text-[#FF7A00]"/>
        <h1 className="font-outfit font-extrabold text-3xl tracking-tighter">Earn Goldly Daily</h1>
      </div>
      <p className="text-white/60 text-sm mb-4">Every action on Hifireels earns you Goldly. Stay active to maximize rewards!</p>

      <div className="rounded-2xl p-4 mb-5 bg-gradient-to-br from-[#FF7A00]/15 to-[#FF7A00]/10 border border-[#FF7A00]/30">
        <div className="flex items-center gap-2 mb-1">
          <Sparkles className="w-4 h-4 text-[#FF7A00]"/>
          <p className="text-xs font-bold text-[#FF7A00] uppercase tracking-wider">Bonus reward</p>
        </div>
        <p className="text-sm leading-relaxed">Stay <b className="text-[#FF7A00]">active 2+ hours within 24 hours</b> and unlock a daily <b>surprise Goldly bonus</b> in your wallet.</p>
      </div>

      <div className="space-y-2" data-testid="earn-rules-list">
        {rules.map((r, i) => (
          <div key={i} data-testid={`earn-rule-${i}`}
            className={`flex items-center gap-3 p-3 rounded-2xl border ${r.bonus ? "border-[#FF7A00]/40 bg-[#FF7A00]/5" : "border-white/10 bg-white/5"}`}>
            <div className="text-2xl flex-shrink-0 w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center">{r.icon}</div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-sm text-white/95">{r.action}</div>
              {r.bonus && <div className="text-[10px] text-[#FF7A00] mt-0.5 font-bold uppercase tracking-wider">⭐ Bonus reward</div>}
            </div>
            <div className="flex-shrink-0 text-right">
              <div className="font-outfit font-extrabold text-base text-[#FF7A00]">
                {typeof r.reward === "number" ? `+${r.reward}` : r.reward}
              </div>
              <div className="text-[9px] text-white/40 uppercase tracking-wider">{typeof r.reward === "number" ? "Goldly" : ""}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-2xl p-4 border border-white/10 bg-white/5">
        <div className="flex items-center gap-2 mb-2">
          <Gift className="w-4 h-4 text-[#FF2A5F]"/>
          <h3 className="font-bold text-sm">Pro tip</h3>
        </div>
        <p className="text-xs text-white/70 leading-relaxed">Engage daily and combine actions. A single hour of activity can easily earn you <b className="text-[#FF7A00]">200-500 Goldly</b> across follows, likes, comments and views.</p>
      </div>

      <Link to="/social-rewards" data-testid="goto-social-rewards"
        className="block mt-5 p-4 rounded-2xl border border-[#FF2A5F]/40 bg-gradient-to-r from-[#FF2A5F]/10 to-[#FF7A00]/5 active:scale-[0.99]">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-outfit font-extrabold text-base text-[#FF2A5F]">Earn 100+ Goldly on Social Media →</div>
            <p className="text-xs text-white/60 mt-0.5">Follow Hifireels on YouTube, Instagram &amp; Facebook</p>
          </div>
        </div>
      </Link>
    </div>
  );
}
